import * as auth from './auth';
import * as dialog from './dialog';
import * as upload from './upload/';
import * as notification from './notification';
import * as files from './files';
import * as socket from './socket';
import * as search from './search';

export default {
  auth,
  dialog,
  upload,
  files,
  notification,
  socket,
  search
}
